'use client'

import type { SortConfig, SortKey } from '@/lib/merge-stream/types'
import { cn } from '@/lib/utils'
import { ArrowDown, ArrowUp, ArrowUpDown } from 'lucide-react'

// Re-export from canonical location
export { formatPrice, formatVolume } from '@/utils/formatting'

type SortableHeaderProps = {
	label: string
	sortKey: SortKey
	currentSort: SortConfig
	onSort: (key: SortKey) => void
	className?: string
}

export function SortableHeader({
	label,
	sortKey,
	currentSort,
	onSort,
	className,
}: SortableHeaderProps) {
	const isActive = currentSort.key === sortKey
	const Icon = isActive ? (currentSort.direction === 'desc' ? ArrowDown : ArrowUp) : ArrowUpDown

	return (
		<button
			type="button"
			onClick={() => onSort(sortKey)}
			className={cn(
				'flex items-center gap-1 font-normal text-xs transition-colors hover:text-foreground',
				isActive ? 'text-foreground' : 'text-muted-foreground',
				className
			)}
		>
			{label}
			<Icon className="h-3 w-3" />
		</button>
	)
}
